/* import __COLOCATED_TEMPLATE__ from './multiple-input.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import PrettyNum from '@ebiz/pretty-num';

const DEFAULT_PRETTY_NUM_TYPE = 'eng3';

export default class MultipleInput extends Component {
  get displayItem2Value() {
    return this.prettyNumFn(this.args.item2Value);
  }

  get isDisabled() {
    return this.args.item1Disabled;
  }

  get item1Hidden() {
    return this.args.item1Hidden;
  }

  get item2Hidden() {
    return this.args.item2Hidden;
  }

  get item1ErrorsExist() {
    return this.args.item1ErrorsExist;
  }

  get item2ErrorsExist() {
    return this.args.item2ErrorsExist;
  }

  prettyNumFn(value) {
    const prettyNumType = DEFAULT_PRETTY_NUM_TYPE;
    let prettyNumFns = {
      eng3: (value) => PrettyNum.eng3(value),
      eng4: (value) => PrettyNum.eng4(value),
    };
    return prettyNumType in prettyNumFns ? prettyNumFns[prettyNumType](value) : value;
  }

  @action handleItem1OnValueChange(value) {
    // this should handle the value change for the current item
    if (this.args.item1OnValueChange) this.args.item1OnValueChange(value);

    // this should handle any value change in the group
    if (this.args.onAnyValueChange) this.args.onAnyValueChange(value);
  }

  @action handleItem2OnValueChange(value) {
    // this should handle the value change for the current item
    if (this.args.item2OnValueChange) this.args.item2OnValueChange(value);

    // this should handle any value change in the group
    if (this.args.onAnyValueChange) this.args.onAnyValueChange(value);
  }
}
